import { Box, Button, Paper, Typography } from '@mui/material';
import { Info, X } from 'phosphor-react';
import React from 'react';

interface LibraryIntroBannerProps {
  libraryName?: string;
  onClose: () => void;
  show: boolean;
}

export const LibraryIntroBanner: React.FC<LibraryIntroBannerProps> = ({ libraryName, onClose, show }) => {
  if (!show) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        p: 3,
        borderRadius: '12px',
        mb: 4,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Info size={32} weight="fill" />
        <Box>
          <Typography variant="h6" fontWeight={600}>
            Introducing the {libraryName}
          </Typography>
          <Typography variant="body2">
            You can explore and enroll in courses that look interesting to you.
          </Typography>
        </Box>
      </Box>
      <Button onClick={onClose} sx={{ minWidth: 'auto', p: 1 }} color="inherit">
        <X size={20} weight="bold" />
      </Button>
    </Paper>
  );
};